

var _angular = require('angular');

var _squid = require('squid');

var _uiRouter = require('uiRouter');

var _logger = require('xo-beaver/dist/logger');

var _index = require('xo-device-info/dist/index');

var _model = require('xo-tracking/dist/model');

var _kmliUpsell = require('./kmliUpsell');

var _auth = require('xo-models/src/auth');

var _ui = require('xo-ui-components/src/accessibility/ui');

var _ui2 = _interopRequireDefault(_ui);

var _ul = require('../unified-login/ul');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoOnetouchUpsell', function () {

    return {
        template: _template2['default'],
        scope: {
            token: '=?',
            onComplete: '=?',
            disableCloseButton: '=?',
            ignoreBgClicks: '=?'
        },
        controller: ['$scope', '$element', function ($scope, $element) {
            $scope.oneTouchFlowName = _uiRouter.$stateParams.oneTouchFlowName;
            $scope.modalActive = false;
            $scope.locale = _squid.$LocaleModel.instance();
            $scope.disableCloseButton = $scope.disableCloseButton || _index.$DeviceInfo.isDevice();
            $scope.upsellOptInDisplayed = false;
            var ulMeta = _squid.$config.ulMeta || {};
            var PAYPAL = window.PAYPAL || {};
            var ulTimeOutValue = 5000;
            var ulTimeoutPromise = null;

            var fptiData = _kmliUpsell.$KmliUpsell.getFPTIAttributes();

            if (!$scope.onComplete) {
                $scope.onComplete = function (params) {
                    _auth.$AuthModel.instance().retrieve().then(function (auth) {
                        auth.isKmliSet = params && params.isKmliSet;
                        _uiRouter.$state.go('checkout.review');
                    });
                };
            }

            _kmliUpsell.$KmliUpsell.eligible().then(function (eligibility) {
                if (eligibility && eligibility.interstitial && eligibility.interstitial.color) {
                    $scope.color = eligibility.interstitial.color;
                    $scope.showUpsellBanner = eligibility.banner;
                }
            });

            function closeInterstitial(params) {
                $('#wrapper > xo-spinner').attr('style', '');
                $('body').removeClass('kmliUpsellActive');
                $element.removeClass('upsellOpen');
                $scope.onComplete(params);
            }

            function failureHandler(reason) {
                _logger.$logger.info('KMLI_UPSELL_error_' + reason);
                closeInterstitial();
            }

            var startTimerTS;

            function startTimer(tag) {
                startTimerTS = Date.now();
                _logger.$logger.info('KMLI_UPSELL_START_TIMER_' + tag, {
                    startTime: startTimerTS
                });

                _logger.$logger.info('checkout_fpti', {
                    'from': 'Interstitial_Timer',
                    'to': 'prepare_' + tag
                });

                ulTimeoutPromise = (0, _angular.$timeout)(function () {
                    var stop_time = Date.now();
                    var time_taken = stop_time - startTimerTS;

                    _logger.$logger.info('checkout_fpti', {
                        'from': 'Interstitial_Timer',
                        'to': 'process_timeout',
                        'int_error_code': 'ULLOGIN_TIMEOUT',
                        'int_error_description': 'ULLOGIN_TIMEOUT',
                        'error_source': 'unifiedloginnodeweb',
                        'error_type': 'soft_decline',
                        'page_load_time': time_taken
                    });
                    failureHandler('timedout');
                    _angular.$rootScope.$emit('loaded');
                }, ulTimeOutValue);
            }

            function stopTimer(tag) {
                var stopTimerTS = Date.now();
                var timeTaken = stopTimerTS - startTimerTS;

                _logger.$logger.info('KMLI_UPSELL_STOP_TIMER_' + tag, {
                    stopTimer: stopTimerTS,
                    page_load_time: timeTaken
                });

                _logger.$logger.info('checkout_fpti', {
                    'from': 'Interstitial_Timer',
                    'to': 'process_' + tag,
                    'page_load_time': timeTaken
                });

                if (ulTimeoutPromise) {
                    _angular.$timeout.cancel(ulTimeoutPromise);
                }
            }

            function logSubmit(data) {
                var fptiPayload = {
                    'from': fptiData.stateName,
                    'to': 'process' + fptiData.transInfix + 'optin'
                };

                if (data && data.errorCode) {
                    angular.extend(fptiPayload, {
                        'int_error_code': data.errorCode,
                        'error_type': 'hard_decline',
                        'error_source': 'unifiedloginnodeweb'
                    });
                }
                _logger.$logger.info('checkout_fpti', fptiPayload);
            }

            $scope.hideModal = function (event) {
                if (event) {
                    event.preventDefault();
                } else if ($scope.ignoreBgClicks) {
                    return;
                }

                _logger.$logger.info('checkout_fpti', {
                    'from': fptiData.stateName,
                    'to': 'process' + fptiData.transInfix + 'decline',
                    'click_source': 'close_button'
                });

                closeInterstitial();
            };

            var ulEventHandlers = {
                'oneTouchInterstitialOptInLoaded': function oneTouchInterstitialOptInLoaded(data) {
                    stopTimer(data.event);
                    _angular.$rootScope.$emit('loaded');
                    $('#wrapper > xo-spinner').hide();
                    $('body').addClass('kmliUpsellActive');

                    // CSS transition to open upsell modal and set modal to trap focus after open
                    (0, _angular.$timeout)(function () {
                        $element.addClass('upsellOpen');
                        $element.one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function () {
                            $scope.$apply(function () {
                                $scope.modalActive = true;
                                // Focus Continue button in iframe
                                $('#injectedOneTouchInterstitial').focus();

                                var escHandler = function escHandler(event) {
                                    if (event.keyCode === _ui2['default'].KEYS.ESC) {
                                        $scope.hideModal();
                                    }
                                };

                                // Add handler to iframe document, as events do not propagate past the iframe
                                $element.find('iframe').contents().on('keydown', escHandler);
                                $element.on('keydown', escHandler);
                            });
                        });
                    });
                },
                'oneTouchInterstitialOptInAttempted': function oneTouchInterstitialOptInAttempted(data) {
                    _angular.$rootScope.$emit('loading');
                    startTimer(data.event);
                },
                'oneTouchInterstitialOptInSuccess': function oneTouchInterstitialOptInSuccess(data) {
                    stopTimer(data.event);
                    _angular.$rootScope.$emit('loaded');
                    logSubmit();
                    closeInterstitial(data);
                },
                'oneTouchInterstitialOptInFailed': function oneTouchInterstitialOptInFailed(data) {
                    stopTimer(data.event);
                    _angular.$rootScope.$emit('loaded');
                    logSubmit({ errorCode: data.event });
                    closeInterstitial(data);
                },
                'oneTouchInterstitialOptInNotAuthorized': function oneTouchInterstitialOptInNotAuthorized(data) {
                    stopTimer(data.event);
                    logSubmit({ errorCode: data.event });
                    _angular.$rootScope.$emit('loaded');
                    closeInterstitial(data);
                },
                'oneTouchInterstitialOptInNotNowClicked': function oneTouchInterstitialOptInNotNowClicked(data) {
                    _logger.$logger.info('checkout_fpti', {
                        'from': fptiData.stateName,
                        'to': 'process' + fptiData.transInfix + 'decline',
                        'click_source': 'not_now_link'
                    });
                    closeInterstitial(data);
                }
            };

            function postMessageHandler(response) {
                (0, _angular.$timeout)(function () {
                    _logger.$logger.info('ul_postmessaged_received', response);
                    var data = response.data || response.error;
                    var eventId = data && data.event;

                    if (eventId) {
                        _logger.$logger.debug('KMLI_UPSELL_' + eventId, response);
                        var handler = ulEventHandlers[eventId];

                        if (handler) {
                            handler(data);
                        }
                    }
                });
            }

            function upsellOptInDisplayed() {
                return _auth.$AuthModel.instance().retrieve().then(function (auth) {
                    if (auth.upsellOptInDisplayed) {
                        $scope.upsellOptInDisplayed = true;
                    }
                });
            }

            function loadOneTouchUpsell() {
                // eslint-disable-line no-unused-vars
                upsellOptInDisplayed().then(function () {
                    // If the optin upsell is already displayed, no need to display again.
                    if ($scope.upsellOptInDisplayed) {
                        $scope.onComplete();
                    } else {
                        _angular.$rootScope.$emit('loading');

                        var options = {
                            targetElement: document.getElementById('injectedOneTouchInterstitial'),
                            queryParams: {
                                'stsRedirectUri': ulMeta.stsReturnUrl,
                                'country.x': $scope.locale.country,
                                'locale.x': $scope.locale.getLocaleCode(),
                                'flowId': $scope.token,
                                'correlationId': _model.$CalDataModel.getCalCorrId(),
                                'flowName': $scope.oneTouchFlowName
                            },
                            iframePathname: '/signin/activate-one-touch',
                            onPostMessage: postMessageHandler
                        };

                        angular.extend(options.queryParams, _kmliUpsell.$KmliUpsell.getOptions());

                        if (_squid.$config.deploy.isLocal()) {
                            if (_squid.$meta.stage) {
                                options.origin = 'https://' + _squid.$meta.stage;
                            } else {
                                // if no stage url shows up then use any backup url for origin
                                options.origin = _squid.$config.onboarding.url.split('/webapps/')[0];
                            }
                        }

                        if (PAYPAL && PAYPAL.unifiedLogin) {
                            startTimer('initializeUpsell');
                            PAYPAL.unifiedLogin.inject(options);
                        } else {
                            failureHandler('PAYPAL.unifiedLogin_undefined');
                        }
                    }
                });
            }

            (0, _angular.$timeout)(function () {
                $element.addClass('upsellOpen');
            });

            $scope.optinOneTouch = function () {
                var flowName = 'checkoutInterstitial'; // login interstitial flow
                var fptiPayload = {
                    stateName: fptiData.stateName,
                    transInfix: 'process' + fptiData.transInfix + 'optin'
                };
                var silent = true;

                return _ul.$ul.optInToOneTouch($scope.token, _squid.$locale.country, _squid.$locale.getLocaleCode(), silent, fptiPayload, flowName).then(closeInterstitial({ isKmliSet: true }))['catch'](function (err) {
                    closeInterstitial({
                        isKmliSet: false,
                        error: err
                    });
                });
            };
        }]
    };
});

_angular.$rootScope;

_angular.$timeout;

_squid.$config;

_squid.$locale;

_squid.$LocaleModel;

_squid.$meta;

_uiRouter.$state;

_uiRouter.$stateParams;

_logger.$logger;

_index.$DeviceInfo;

_model.$CalDataModel;

_kmliUpsell.$KmliUpsell;

_auth.$AuthModel;

_ul.$ul;


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-login-components/src/onetouch-interstitial/directive.js
// module id = ../node_modules/xo-login-components/src/onetouch-interstitial/directive.js
// module chunks = 0